import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import * as Sentry from '@sentry/react';
import { useDispatch } from 'react-redux';

import reducer from './reduces/reducer';

const sentryReduxEnhancer = Sentry.createReduxEnhancer();

type AppDispatch = typeof store.dispatch;

export const useAppDispatch: () => AppDispatch = useDispatch;

export const store = createStore(
  reducer,
  compose(applyMiddleware(thunk), sentryReduxEnhancer)
);
